import React, { useEffect, useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import { useUpdateBillingInfo } from "../../../../../queries/billing";
import toast from "react-hot-toast";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import { Loader2 } from "lucide-react";

const EditBillingInfoModal = ({
  isOpen,
  onClose,
  paymentMethod_id,
  billing_details = {},
  userActiveLocation
}) => {

  const { mutateAsync: updateBillingInfo } = useUpdateBillingInfo(userActiveLocation?.id);
  const [form, setForm] = useState({
    name: billing_details.name || "",
    email: billing_details.email || "",
    phone: billing_details.phone || "",
    line1: billing_details.address?.line1 || "",
    line2: billing_details.address?.line2 || "",
    city: billing_details.address?.city || "",
    state: billing_details.address?.state || "",
    postal_code: billing_details.address?.postal_code || "",
    country: billing_details.address?.country || "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (billing_details) {
      setForm({
        name: billing_details.name || "",
        email: billing_details.email || "",
        phone: billing_details.phone || "",
        line1: billing_details.address?.line1 || "",
        line2: billing_details.address?.line2 || "",
        city: billing_details.address?.city || "",
        state: billing_details.address?.state || "",
        postal_code: billing_details.address?.postal_code || "",
        country: billing_details.address?.country || "",
      });
    }
  }, [billing_details]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      paymentMethod_id,
      billing_details: {
        address: {
          line1: form.line1,
          line2: form.line2,
          city: form.city,
          state: form.state,
          postal_code: form.postal_code,
          country: form.country,
        },
        name: form.name,
        email: form.email,
        phone: form.phone,
      },
      customer_id: userActiveLocation?.customer_id
    };

    try {
      const data = await updateBillingInfo(payload);
      if (data?.data) {
        toast.success("Billing information updated!");
        setLoading(false);
        onClose();
        return;
      }
    } catch (err) {
      // fall through to the generic error toast below
    }
    toast.error("Failed to update billing information");
    setLoading(false);
  };

  return (
    <CommonModal
      title="Edit Billing Information"
      showAlert={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit} className="space-y-3 p-2 overflow-y-auto max-h-[80vh]">
        <div>
          <label className="block text-sm mb-1">Name</label>
          <Input
            name="name"
            value={form.name}
            onChange={handleChange}
            type="text"
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Email</label>
          <Input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Phone</label>
          <Input
            name="phone"
            type="text"
            value={form.phone}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Address Line 1</label>
          <Input
            name="line1"
            type="text"
            value={form.line1}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Address Line 2</label>
          <Input
            name="line2"
            type="text"
            value={form.line2}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className="block text-sm mb-1">City</label>
          <Input
            name="city"
            type="text"
            value={form.city}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">State</label>
          <Input
            name="state"
            type="text"
            value={form.state}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Postal Code</label>
          <Input
            name="postal_code"
            type="text"
            value={form.postal_code}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Country</label>
          <Input
            name="country"
            type="text"
            value={form.country}
            onChange={handleChange}
            required
          />
        </div>
        <Button type="submit" disabled={loading} className="w-full mt-2">
          {loading && <Loader2 className="animate-spin" />}
          {loading ? "Saving..." : "Save Billing Info"}
        </Button>
      </form>
    </CommonModal>
  );
};

export default EditBillingInfoModal;
